import { createFileRoute } from '@tanstack/react-router';

import { RemediationSummaryPage } from '@/features/code-remedy/RemediationSummaryPage';

export const Route = createFileRoute('/_protected/t/$tenantId/code-modernization/$remedyId/report')({
  component: RemediationSummaryRoute,
});

function RemediationSummaryRoute() {
  const { remedyId } = Route.useParams();

  return <RemediationSummaryPage remedyId={remedyId} />;
}
